import Layout from '@/layout/paycools-index.vue'

export const customerServiceRouter = {
  path: '/customerServiceManage',
  component: Layout,
  // redirect: '/customerServiceManage/list',
  name: 'Customer_Service_Manage',
  meta: { title: 'customerService_manage', icon: 'customerService' },
  children: [
    {
      path: 'query/pay',
      name: 'Customer_Service_Query_Pay',
      component: () => import('@/views/paycools/customer-service/query-pay'),
      meta: {
        title: 'customerService_manage_query_pay', noCache: false,
        auth: ['AUTH_CODE_CUSTOMER_SERVICE_PAYIN']
      }
    },
    {
      path: 'query/refund',
      name: 'Customer_Service_Query_Refund',
      component: () => import('@/views/paycools/customer-service/query-refund'),
      meta: {
        title: 'refund_transaction_query', noCache: false,
        auth: ['AUTH_CODE_REFUND_TRANSACTION_CUSTOMER_SEARCH']
      }
    },
    {
      path: 'query/payout',
      name: 'Customer_Service_Query_Payout',
      component: () => import('@/views/paycools/customer-service/query-payout'),
      meta: {
        title: 'customerService_manage_query_payout', noCache: false,
        auth: ['AUTH_CODE_CUSTOMER_SERVICE_PAYOUT']
      }
    },
    {
      path: 'query/cardVerification',
      name: 'Customer_Service_Query_Card_Verification',
      component: () => import('@/views/paycools/customer-service/query-card-verification'),
      meta: {
        title: 'customer_service_manage_query_card_verification', noCache: false,
        auth: ['AUTH_CARD_VALIDATION_CUSTOMER_SERVICE']
      }
    },
    {
      path: 'query/paymentReceiptVerification',
      name: 'Payment_Receipt_Verification_Inquiry',
      component: () => import('@/views/paycools/data/payment-slip-validation.vue'),
      meta: {
        title: 'payment_receipt_verification_inquiry', noCache: false,
        auth: ['AUTH_PAYMENT_SLIP_VALIDATION_TRANSACTION_SEARCH']
      }
    },
    {
      path: 'ticket',
      name: 'Customer_Service_Ticket_List',
      component: () => import('@/views/paycools/customer-service/ticket-list'),
      meta: {
        title: 'customer_service_ticket_list', noCache: false,
        auth: ['AUTH_CODE_CUSTOMER_SERVICE']
      }
    }
  ]
}
